import PlusCircleFillSVG from '../../assets/svg/plus-circle-fill.svg';

export default PlusCircleFillSVG;
